module.exports = import("https://esm.sh/react-big-calendar");;